module.exports = __webpack_public_path__ + "static/img/5.50e98b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/5.png
// module id = g41H
// module chunks = 0